import { useState } from "react";

import { Popover, PopoverTrigger } from "@similarweb/ui-components";

import { COMPANY_ANALYSIS_OVERVIEW } from "app/pages/sales-intelligence/constants/routes";
import useEnrichedRecents from "app/pages/sales-intelligence/modules/company-analysis/hooks/useEnrichedRecents";
import { useCompanyDomainInfoQuery } from "app/pages/sales-intelligence/modules/company-analysis/queries/useCompanyDomainInfoQuery";
import CompanyBreadcrumbContent from "app/pages/sales-intelligence/pages/company-analysis/containers/header/PageHeaderBreadcrumbs/CompanyBreadcrumbContent";
import useCurrentStateAndParamsWithFixedDomain from "app/pages/sales-intelligence/sub-modules/account-overview/shared/hooks/useCurrentStateAndParamsWithFixedDomain";
import { proNavigator } from "single-spa/react-app/ProNavigator";

import { StyledPopoverContent, StyledQueryBarItem } from "./styles";

const CompanyBreadcrumbItem = ({
    onCompanyClick,
    onWebsiteClick,
    isDomainBreadcrumbVisible,
    onOpen,
    onCompanyBreadcrumbClick,
}: {
    onCompanyClick: ({ key, companyName }: { key: string; companyName: string }) => void;
    onWebsiteClick: (domain: string) => void;
    isDomainBreadcrumbVisible?: boolean;
    onOpen?: () => void;
    onCompanyBreadcrumbClick?: () => void;
}) => {
    const { params } = useCurrentStateAndParamsWithFixedDomain();
    const { data: companyInfo } = useCompanyDomainInfoQuery(params.key);

    const { recentUniqueCompanies } = useEnrichedRecents();

    const [isOpen, setIsOpen] = useState(false);

    const handleCompanyClick = ({ key, companyName }: { key: string; companyName: string }) => {
        setIsOpen(false);
        onCompanyClick({ key, companyName });
    };

    const handleWebsiteClick = (domain: string) => {
        setIsOpen(false);
        onWebsiteClick(domain);
    };

    const handleToggle = (open: boolean) => {
        setIsOpen(open);
    };

    const handleCompanyBreadcrumbClick = () => {
        if (isDomainBreadcrumbVisible && companyInfo?.mainDomain) {
            void proNavigator.go(COMPANY_ANALYSIS_OVERVIEW, {
                key: companyInfo?.mainDomain,
            });
            onCompanyBreadcrumbClick?.();
        } else {
            setIsOpen(true);
            onOpen?.();
        }
    };

    return (
        <Popover
            isClickOutsideEnabled
            open={isOpen}
            onOpenChange={handleToggle}
            placement="bottom-start"
            offset={-36}
        >
            <PopoverTrigger asChild>
                <span>
                    <StyledQueryBarItem
                        text={companyInfo?.name || companyInfo?.mainDomain || ""}
                        image={companyInfo?.favIcon || ""}
                        onItemClick={handleCompanyBreadcrumbClick}
                        renderIconComponent={isDomainBreadcrumbVisible ? () => <></> : undefined}
                    />
                </span>
            </PopoverTrigger>
            <StyledPopoverContent>
                <CompanyBreadcrumbContent
                    onCompanyClick={handleCompanyClick}
                    onWebsiteClick={handleWebsiteClick}
                    recentCompanies={recentUniqueCompanies}
                />
            </StyledPopoverContent>
        </Popover>
    );
};

export default CompanyBreadcrumbItem;
